"use client"
import React, { useState, useEffect } from "react"
import { Link } from "react-router-dom"
import { Badge } from "../../components/ui/badge"
import { Button } from "../../components/ui/button"
import { Input } from "../../components/ui/input"
import SEO from "../SEO"
import { Newspaper, Calendar, ExternalLink, Search, TrendingUp, Users, Award, Building2 } from "lucide-react"

export default function InTheNews() {
  const inTheNewsSchema = [
  {
    "@context": "https://schema.org",
    "@type": "Organization",
    "@id": "https://pranaamhospitals.com/#organization",
    "name": "Pranaam Hospitals",
    "url": "https://pranaamhospitals.com/",
    "logo": "https://pranaamhospitals.com/images/pranaam-logo.png",
    "description": "Explore Pranaam Hospitals in the news — media coverage, press mentions, awards, and recognitions highlighting our excellence in healthcare services in Hyderabad.",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "1-58/6/40 & 41, Mythri Nagar, Madinaguda, Miyapur",
      "addressLocality": "Hyderabad",
      "addressRegion": "Telangana",
      "postalCode": "500050",
      "addressCountry": "IN"
    },
    "contactPoint": {
      "@type": "ContactPoint",
      "contactType": "customer service",
      "telephone": "+91-99660-60000",
      "email": "info@pranaamhospitals.in",
      "availableLanguage": [
        "English",
        "Telugu",
        "Hindi"
      ]
    },
    "sameAs": [
      "https://www.facebook.com/pranaamhospitals",
      "https://www.instagram.com/pranaamhospitals",
        ]
  },
  {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "@id": "https://pranaamhospitals.com/inthenews#breadcrumb",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": "https://pranaamhospitals.com/"
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": "About",
        "item": "https://pranaamhospitals.com/about"
      },
      {
        "@type": "ListItem",
        "position": 3,
        "name": "In The News",
        "item": "https://pranaamhospitals.com/about/inthenews"
      }
    ]
  }
];

  const [searchQuery, setSearchQuery] = useState("")
  const [selectedYear, setSelectedYear] = useState("all")

  const [newsData, setNewsData] = useState([])

  const [data, setData] = useState(null)
    const [pageData, setPageData] = useState(null);
useEffect(() => {
  fetch("/wp-json/wp/v2/pages?slug=inthenews")
    .then((res) => res.json())
    .then((data) => {
      if (data && data[0]) {
        setPageData(data[0]);
      }
    });
}, []);
 useEffect(() => {
  fetch("https://pranaamhospitals.com/wp-json/custom/v1/in-the-news?page_id=21401")
    .then(res => res.json())
    .then(res => {
      console.log("NEWS API 👉", res)
      setNewsData(res.items || [])
    })
    .catch(error => {
      console.error("Error fetching news data:", error)
      setNewsData([])
    })
}, [])

  const years = ["all", "2025", "2024", "2023", "2021", "2020"]

 const filteredNews = React.useMemo(() => {
   console.log('Filtering with query:', searchQuery, 'year:', selectedYear)
   console.log('Total articles:', newsData.length)
   
   if (!newsData || newsData.length === 0) {
     console.log('No news data available')
     return []
   }
   
   return newsData.filter((article) => {
     // Year filter
     const yearMatch = selectedYear === "all" || article.year === selectedYear
     
     // Search filter
     let searchMatch = true
     if (searchQuery && searchQuery.trim()) {
       const query = searchQuery.toLowerCase().trim()
       const headline = article.headline ? article.headline.toLowerCase() : ''
       const publication = article.publication ? article.publication.toLowerCase() : ''
       
       searchMatch = headline.includes(query) || publication.includes(query)
       console.log(`Article "${article.headline}" matches search "${query}":`, searchMatch)
     }
     
     return yearMatch && searchMatch
   })
 }, [newsData, searchQuery, selectedYear])

console.log('Final filtered results:', filteredNews.length)


  const acf = pageData?.acf || {};
  const seo = pageData?.seo || {};
 

  return (
    <>
     <SEO
          title={seo.title || "Pranaam Hospitals in the News | Media Coverage & Healthcare Achievements"}
          description={seo.description || "Explore Pranaam Hospitals in the news — media coverage, press mentions, awards, and recognitions highlighting our excellence in healthcare services in Hyderabad."}
          canonical={seo.canonical || "https://pranaamhospitals.com/inthenews"}
          robots={Array.isArray(seo.robots) ? seo.robots.join(", ") : seo.robots || "index, follow"}
          keywords={acf.key_words || ""}
          ogTitle={seo.og_title}
          ogDescription={seo.og_description}
          ogImage={seo.og_image || seo.featured_image}
          twitterTitle={seo.twitter_title}
          twitterDescription={seo.twitter_description}
          author="Pranaam Hospitals"
          publisher="Pranaam Hospitals"
  schema={inTheNewsSchema}
/>

    <div className="min-h-screen bg-white">
      <main>
        {/* Hero Section */}
        <section className="relative bg-gradient-to-r from-primary/10 to-primary/5 py-16 md:py-24">
          <div className="container px-4 mx-auto">
            <div className="max-w-4xl mx-auto text-center">
              <Badge className="mb-4 px-3 py-1">Media Coverage</Badge>
              <h1 className="mb-6 text-4xl font-bold tracking-tight md:text-5xl lg:text-6xl">
                In The <span className="text-primary">News</span>
              </h1>
              <p className="mb-8 text-lg text-gray-700 max-w-3xl mx-auto">
                Discover how Pranaam Hospitals continues to make headlines through our emergency response, innovative
                healthcare solutions, and commitment to community wellbeing.
              </p>
              <div className="flex flex-wrap justify-center gap-4 mt-8">
                <Badge variant="outline" className="px-4 py-2 text-base">
                  <Newspaper className="w-4 h-4 mr-2" />
                  26+ Media Mentions
                </Badge>
                <Badge variant="outline" className="px-4 py-2 text-base">
                  <Calendar className="w-4 h-4 mr-2" />6 Years Featured
                </Badge>
                <Badge variant="outline" className="px-4 py-2 text-base">
                  <TrendingUp className="w-4 h-4 mr-2" />
                  National & Regional
                </Badge>
              </div>
            </div>
          </div>
        </section>

        {/* Introduction */}
        <section className="py-12 bg-white">
          <div className="container px-4 mx-auto">
            <div className="max-w-3xl mx-auto text-center">
              <p className="text-lg text-gray-700">
                Pranaam Hospitals has been consistently recognized by leading media outlets for our exceptional
                healthcare services, rapid emergency response, groundbreaking innovations like India's first Health ATM,
                and strategic partnerships that advance the medical field.
              </p>
            </div>
          </div>
        </section>

        {/* Search and Filter Section */}
        <section className="py-8 bg-gray-100">
          <div className="container px-4 mx-auto">
            <div className="max-w-4xl mx-auto space-y-6">
              {/* Search Bar */}
              <div>
                <div className="relative">
                  <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" />
                  <Input
                    type="text"
                    placeholder="Search articles by headline or publication..."
                    value={searchQuery}
                    onChange={(e) => {
                      console.log('Search query changed:', e.target.value)
                      setSearchQuery(e.target.value)
                    }}
                    className="pl-10 h-12 bg-white"
                  />
                </div>
                {searchQuery && (
                  <div className="mt-2 text-sm text-gray-600">
                    Searching for: "{searchQuery}" - Found {filteredNews.length} results
                  </div>
                )}
              </div>

              {/* Year Filter */}
              <div className="flex flex-wrap gap-3 justify-center">
                {years.map((year) => (
                  <Button
                    key={year}
                    variant={selectedYear === year ? "default" : "outline"}
                    onClick={() => setSelectedYear(year)}
                    className="rounded-full"
                  >
                    {year === "all" ? "All Years" : year}
                  </Button>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* News Grid */}
        <section className="py-12 bg-white">
          <div className="container px-4 mx-auto">
            <div className="max-w-6xl mx-auto">
              {filteredNews.length > 0 ? (
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                  {filteredNews.map((article, index) => (
                    <div
                      key={index}
                      className="bg-white border border-gray-200 rounded-lg p-6 hover:shadow-lg transition-all group"
                    >
                      <div className="flex items-start gap-4">
                        <div className="flex-shrink-0">
                          <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-primary/10 group-hover:bg-primary transition-colors">
                            <Newspaper className="w-6 h-6 text-primary group-hover:text-white transition-colors" />
                          </div>
                        </div>
                        <div className="flex-1 min-w-0">
                          <div className="flex items-center gap-2 mb-2">
                            <Calendar className="w-4 h-4 text-primary flex-shrink-0" />
                            <span className="text-sm text-gray-600">{article.date}</span>
                          </div>
                          <h2 className="font-bold mb-2 text-gray-900 group-hover:text-primary transition-colors line-clamp-2">
                            {article.headline}
                          </h2>
                          <p className="text-sm text-gray-600 mb-3">{article.publication}</p>
                          <Button
                              asChild
                              variant="ghost"
                              size="sm"
                              className="text-primary hover:text-primary/80 p-0 h-auto font-medium"
                            >
                              <a href={article.link} target="_blank" rel="noopener noreferrer">
                                Read Article
                                <ExternalLink className="w-4 h-4 ml-1" />
                              </a>
                            </Button>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="text-center py-12">
                  <Newspaper className="w-16 h-16 text-gray-300 mx-auto mb-4" />
                  <h3 className="text-xl font-semibold mb-2">No articles found</h3>
                  <p className="text-gray-600 mb-4">Try adjusting your search or filters</p>
                  <Button
                    variant="outline"
                    onClick={() => {
                      setSearchQuery("")
                      setSelectedYear("all")
                    }}
                  >
                    Clear Filters
                  </Button>
                </div>
              )}
            </div>
          </div>
        </section>

        {/* Media Recognition Stats */}
        <section className="py-12 bg-gray-100">
          <div className="container px-4 mx-auto">
            <div className="max-w-6xl mx-auto">
              <div className="text-center mb-12">
                <Badge className="mb-2">Media Impact</Badge>
                <h2 className="mb-4 text-3xl font-bold md:text-4xl">Our Media Recognition</h2>
                <p className="text-gray-700 max-w-2xl mx-auto">
                  Coverage spanning emergency response, healthcare innovation, and community partnerships
                </p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                <div className="bg-white rounded-lg p-6 text-center border border-gray-200 hover:shadow-md transition-shadow">
                  <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-primary/10 mb-4">
                    <TrendingUp className="w-6 h-6 text-primary" />
                  </div>
                  <h3 className="text-3xl font-bold text-primary mb-2">15+</h3>
                  <p className="text-gray-600">Emergency Response Coverage</p>
                </div>

                <div className="bg-white rounded-lg p-6 text-center border border-gray-200 hover:shadow-md transition-shadow">
                  <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-primary/10 mb-4">
                    <Award className="w-6 h-6 text-primary" />
                  </div>
                  <h3 className="text-3xl font-bold text-primary mb-2">10+</h3>
                  <p className="text-gray-600">Innovation Features</p>
                </div>

                <div className="bg-white rounded-lg p-6 text-center border border-gray-200 hover:shadow-md transition-shadow">
                  <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-primary/10 mb-4">
                    <Building2 className="w-6 h-6 text-primary" />
                  </div>
                  <h3 className="text-3xl font-bold text-primary mb-2">5+</h3>
                  <p className="text-gray-600">Partnership Announcements</p>
                </div>

                <div className="bg-white rounded-lg p-6 text-center border border-gray-200 hover:shadow-md transition-shadow">
                  <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-primary/10 mb-4">
                    <Users className="w-6 h-6 text-primary" />
                  </div>
                  <h3 className="text-3xl font-bold text-primary mb-2">20+</h3>
                  <p className="text-gray-600">Media Outlets</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-12 bg-white">
          <div className="container px-4 mx-auto">
            <div className="max-w-4xl mx-auto bg-gradient-to-r from-primary to-primary/90 rounded-lg shadow-xl p-8 md:p-12 text-white text-center">
              <h2 className="mb-4 text-3xl font-bold md:text-4xl">Media Inquiries</h2>
              <p className="mb-8 text-lg opacity-90">
                For press releases, interviews, or media partnerships, please contact our media relations team.
              </p>
              <Button size="lg" variant="secondary" asChild>
                <Link to="/contact">Contact Us</Link>
              </Button>
            </div>
          </div>
        </section>
      </main>
    </div>
    </>
  )
}
